import React from 'react';
import { observable, action, runInAction, toJS } from 'mobx';
import { observer } from 'mobx-react';
import { Row, Col, Switch, Modal, Button, Form, Upload, Avatar, Card, message, Divider } from 'antd';
import user_bet_record_store from '@store/User/UserList/UserBetRecordStore';

import UserInfo from './UserInfo';
import UserBetRecordListTable from './UserBetRecordListTable';

@observer
class UserBetRecordModal extends React.Component {
  constructor() {
    super();
    this.state = { someKey: 'someValue' };
  }

  render() {
    return (
      <Modal
        visible={ user_bet_record_store.is_modal_show }
        title={(
          <div>
            <span>
              会员下注记录
            </span>
          </div>
        )}
        style={{
          top: 20,
        }}
        onCancel={ () => {
          user_bet_record_store.closeModal();
        } }
        bodyStyle={{
          height: '90vh',
          overflowY: 'scroll'
        }}
        width="96%"
        footer={null}>
        <UserInfo />
        <div style={{
          height: '48px', lineHeight: '48px', fontSize: '18px'
          }}>投注记录</div>
        <UserBetRecordListTable />
      </Modal>
    );
  }

  componentDidMount() {
    this.setState({ someKey: 'otherValue' });
  }
}

export default UserBetRecordModal;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/User/UserList/UserBetRecord/UserBetRecordModal.jsx